import { render, staticRenderFns } from "./FieldTypeSelect.vue?vue&type=template&id=58089e04&scoped=true&"
import script from "./FieldTypeSelect.vue?vue&type=script&lang=js&"
export * from "./FieldTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./FieldTypeSelect.vue?vue&type=style&index=0&id=58089e04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58089e04",
  null
  
)

export default component.exports